import React from 'react';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

export const TrackingSectionSubtitle = ({ isThirdPartyTagsPermitted, isExternalMetadataPermitted }) => {
    let messageConfig;

    if (isThirdPartyTagsPermitted && isExternalMetadataPermitted) {
        messageConfig = {
            id: 'campaign.advancedOptions.tracking',
            defaultMessage: '3rd Party Tags and External Metadata',
        };
    } else if (isThirdPartyTagsPermitted) {
        messageConfig = {
            id: 'campaign.advancedOptions.tracking.3rd.party.tracking',
            defaultMessage: '3rd Party Tags',
        };
    } else if (isExternalMetadataPermitted) {
        messageConfig = {
            id: 'campaign.advancedOptions.tracking.external.metadata',
            defaultMessage: 'External Metadata',
        };
    }

    return <FormattedMessage id={messageConfig.id} defaultMessage={messageConfig.defaultMessage} />;
};
